console.log("downloads js loaded");
var downloads_api_client = function(
      customer_email,
      shopify_frontend_endpoint_url,
      hmac_digest,
      nonce
    ){
  console.log("running \"downloads_api_client\"");
  var callback_url = null;// this may be set to a server for the sending of notification of emails to customers once their downloads are watermarked and ready for download.
  
  // Declare `murphysDownloadsShopifyResources` as an empty array by default
  let murphysDownloadsShopifyResources = [];
  let nonMurphysDownloadsShopifyResources = [];
  let externalLinksShopifyResources = [];

  function getDownloadFiles(product_id) {
    return $.ajax({
    type: "GET",
    url: shopify_frontend_endpoint_url,
    dataType: 'json',
    data: {functionname: 'getDownloadFiles', arguments: [customer_email, product_id], hmacdigest: hmac_digest, nonce: nonce},
    });
   }	
  
  
  function getData() { 
    //console.log("murphysDownloadsShopifyResources", murphysDownloadsShopifyResources);
    let fetch_thumbnails_and_titles; // this declaration gives the variable scope beyond the if statement.
    //console.log("number of murphys downloads in shopify resources: ", murphysDownloadsShopifyResources.length);
    if (murphysDownloadsShopifyResources.length > 0) {
      // if we have already sourced these from liquid there is no need to have the app spend the time fetching them one by one from shopify
      fetch_thumbnails_and_titles = false;
    } else {
      fetch_thumbnails_and_titles = true;
    }
    return $.ajax({
    type: "GET",
    url: shopify_frontend_endpoint_url,
    dataType: 'json',
    /*data: {functionname: 'add', arguments: [1, 2]},*/
      data: {functionname: 'get_downloads', arguments: [customer_email, fetch_thumbnails_and_titles], hmacdigest: hmac_digest, nonce: nonce},
    });
  }

  function htmlEscape(str) {
  return str
    .replace(/&/g, "&amp;")
    .replace(/'/g, "&#39;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  }

  function cleanAndEscape(str) {
    // 1) Remove any JS-escape backslashes before apostrophes
    let normalized = str.replace(/\\'/g, "'");
    // 2) (Optionally) strip any other stray backslashes
    normalized = normalized.replace(/\\/g, "");
    // 3) HTML-escape the result
    return htmlEscape(normalized);
  }

  function handleData(obj, textstatus, murphysDownloadsShopifyResources, nonMurphysDownloadsShopifyResources, externalLinksShopifyResources, copyToClipboardIconSrc) {
    console.log("handling data now");
    console.log("murphysDownloadsShopifyResources: ", murphysDownloadsShopifyResources);
    console.log("nonMurphysDownloadsShopifyResources: ", nonMurphysDownloadsShopifyResources);
    console.log("externalLinksShopifyResources: ", externalLinksShopifyResources);
    console.log("object:");
    console.log(obj);
    console.log("textstatus:");
    console.log(textstatus);
    
    document.getElementById("downloaditems").innerHTML = '';
    //console.log('murphysDownloadsShopifyResources: ');
    //console.log(JSON.parse(murphysDownloadsShopifyResources));                                                   
    //console.log('nonMurphysDownloadsShopifyResources: ');
    //console.log(JSON.parse(nonMurphysDownloadsShopifyResources));                                                   
    //console.log('externalLinksShopifyResources: ');
    //console.log(JSON.parse(externalLinksShopifyResources));                                                   
      
    if( !('error' in obj) || (nonMurphysDownloadsShopifyResources != '') || (externalLinksShopifyResources != '') ) {
      if (obj.result == undefined || 'error' in obj){
        if (obj.result == undefined){
          console.log('response from request to sfd server is undefined but we are resetting it to a blank array');
        }
        if ('error' in obj){
          console.log('response from request to sfd server indicates an error but we are resetting it to a blank array');
        }
        var response = new Array();
      } else { 
        var response = obj.result;
      }
      console.log("response from sfd api: ");
      console.log(response);
      var arrayLength = response.length;
      //console.log('number of products: '+arrayLength);
       
      //go through products in response and add images and titles from ShopifyResources
      
      for (var count = 0; count < arrayLength; count++) {
        let product_title;
        let product_image_url;
        //console.log(count);
        product = response[count];
        // note that in javascript a variable is in fact a reference to the original object, so when we are editing product we are actually editing element in the original array

        if (murphysDownloadsShopifyResources.length > 0){
          console.log("**murphysDownloadsShopifyResources:");
          console.log(murphysDownloadsShopifyResources);
          // fetch product_title and product_image_html from murphysDownloadsShopifyResources
          console.log("searching murphysDownloadsShopifyResources for ID ",product.ID);

          let target_element = murphysDownloadsShopifyResources.find(item => Number(item.ID) === Number(product.ID));

          if (target_element) {
            console.log("target_element found");
            //product.Name = target_element.Name.replace('\'','\\\'');
            product.Name = cleanAndEscape(product.Name);
            product.Image_url = target_element.Image_url;
          } else {
            console.log("target_element NOT found so using default title for product");
            if (product.Name != null){
              //product.Name = product.Name.replace('\'','\\\'');
              product.Name = cleanAndEscape(product.Name);
            } else {
              product.Name = 'title unknown';
            }
            product.Image_url = '';
          }
        } else {
          // as the name and image_urls have been fetched from Murphys we fix escaping so that they display correctly
          product.Name = product.Name.replace('\'','\\\'');
        }
      }

      // add the non-murphys shopify resources
      console.log("nonMurphysDownloadsShopifyResources:");
      console.log(nonMurphysDownloadsShopifyResources);
      console.log("externalLinksShopifyResources:");
      console.log(externalLinksShopifyResources);
      response = response.concat(nonMurphysDownloadsShopifyResources);
      response = response.concat(externalLinksShopifyResources);                                               
                                                         
      console.log('response plus non-murphys items:');
      console.log(response);
                                                         
      var product = null;
      var arrayLength = response.length;
      //console.log('number of products: '+ response.length);
      
      for (var count = 0; count < arrayLength; count++) {
        //console.log(count);
        product = response[count];
        
        var product_title_action_html = '';
        var image_action_html = '';
        var combined_list_html = '';
        var streams_list_html = '';
        var downloads_list_html = '';
        
           
        // check if image link is given
        if (product.Image_url == null){
          var hide_if_empty = ' hidden';
        } else {
          var hide_if_empty = '';
        }
                  
        if (product.Type == "non_murphys"){
          console.log("non murphys product");
          if (product.video_2_filename != null) {
            var no_of_vimeo_videos = 2;
          } else {
            if (product.video_1_filename != null) {
              var no_of_vimeo_videos = 1;
            }  
          }
          if (product.video_1_filename != null){
            product_title_action_html = '<a style="cursor:pointer" onclick="downloads_client.playVimeoVideo(\''+product.ID+'\',\''+product.Name.replace('\'','\\\'')+'\',\'Video 1 of ' +no_of_vimeo_videos+ '\',\''+product.video_1_filename+'\');">'+product.Name+'</a>'; 
            image_action_html = '<a style="cursor:pointer" onclick="downloads_client.playVimeoVideo(\''+product.ID+'\',\''+product.Name.replace('\'','\\\'')+'\',\'Video 1 of ' +no_of_vimeo_videos+ '\',\''+product.video_1_filename+'\');"><img src="'+product.Image_url+'"'+hide_if_empty+'></a>';
            //streams_list_html += '<p class="cart__remove">&nbsp</p>';
            //downloads_list_html += '<p class="cart__remove">&nbsp</p>';
            combined_list_html +=    
              '<p><span class="cart-item--price-title">\
                <a class="line-item__title link" style="cursor:pointer" onclick="downloads_client.playVimeoVideo(\''+product.ID+'\',\''+product.Name.replace('\'','\\\'')+'\',\'Video 1 of ' +no_of_vimeo_videos+ '\',\''+product.video_1_filename+'\');"><span style="position:relative; width:218px; display:inline-block; text-align:left;">Video 1 of ' +no_of_vimeo_videos+ '</span></a>\
              </span></p>';
          }
          if (product.video_2_filename != null){
            //streams_list_html += '<p class="cart__remove">&nbsp</p>';
            //downloads_list_html += '<p class="cart__remove">&nbsp</p>';
            combined_list_html +=    
              '<p><span class="cart-item--price-title">\
                <a class="line-item__title link" style="cursor:pointer" onclick="downloads_client.playVimeoVideo(\''+product.ID+'\',\''+product.Name.replace('\'','\\\'')+'\',\'Video 2 of ' +no_of_vimeo_videos+ '\',\''+product.video_2_filename+'\');"><span style="position:relative; width:218px; display:inline-block; text-align:left;">Video 2 of ' +no_of_vimeo_videos+ '</span></a>\
              </span></p>';
          }
          if (product.ebook_2_filename != null) {
            var no_of_ebooks = 2;
          } else {
            if (product.ebook_1_filename != null) {
              var no_of_ebooks = 1;
            }  
          }
          // removed because downloads from server are not being used    
          /*
          if (product.ebook_1_filename != null){
            if (product_title_action_html == '') {
              product_title_action_html = '<a style="cursor:pointer" onclick="downloads_client.getEbook(\''+product.ID+'\',\''+product.Name.replace('\'','\\\'')+'\',\'ebook 1 of ' +no_of_ebooks+ '\',\''+product.ebook_1_filename+'\',\''+product.ebook_1_filename_digest+'\');">'+product.Name+'</a>'; 
              image_action_html = '<a style="cursor:pointer" onclick="downloads_client.getEbook(\''+product.ID+'\',\''+product.Name.replace('\'','\\\'')+'\',\'ebook 1 of ' +no_of_ebooks+ '\',\''+product.ebook_1_filename+'\',\''+product.ebook_1_filename_digest+'\');"><img src="'+product.Image_url+'"'+hide_if_empty+'></a>';
            }
            //streams_list_html += '<p class="cart__remove">&nbsp</p>';
            //downloads_list_html += '<p class="cart__remove">&nbsp</p>';
            combined_list_html +=    
              '<p><span class="cart-item--price-title">\
                <a class="line-item__title link" style="cursor:pointer" onclick="downloads_client.getEbook(\''+product.ID+'\',\''+product.Name.replace('\'','\\\'')+'\',\'ebook 1 of ' +no_of_ebooks+ '\',\''+product.ebook_1_filename+'\',\''+product.ebook_1_filename_digest+'\');"><span style="position:relative; width:218px; display:inline-block; text-align:left;">ebook 1 of ' +no_of_ebooks+ '</span></a>\
              </span></p>';
          }
          if (product.ebook_2_filename != null){
            
            //streams_list_html += '<p class="cart__remove">&nbsp</p>';
            //downloads_list_html += '<p class="cart__remove">&nbsp</p>';
            combined_list_html +=    
              '<p><span class="cart-item--price-title">\
                <a class="line-item__title link" style="cursor:pointer" onclick="downloads_client.getEbook(\''+product.ID+'\',\''+product.Name.replace('\'','\\\'')+'\',\'ebook 2 of ' +no_of_ebooks+ '\',\''+product.ebook_2_filename+'\',\''+product.ebook_2_filename_digest+'\');"><span style="position:relative; width:218px; display:inline-block; text-align:left;">ebook 2 of ' +no_of_ebooks+ '</span></a>\
              </span></p>';
          }
          */
          //Added because external links are being used instead of downloads from the server
          if (product.ebook_1_filename != null){
            if (product_title_action_html == '') {
              product_title_action_html = '<a style="cursor:pointer" href="'+product.ebook_1_filename+'" target="_blank">'+product.Name+'</a>'; 
              image_action_html = '<a style="cursor:pointer" href="'+product.ebook_1_filename+'" target="_blank"><img src="'+product.Image_url+'"'+hide_if_empty+'></a>';
            }
            //streams_list_html += '<p class="cart__remove">&nbsp</p>';
            //downloads_list_html += '<p class="cart__remove">&nbsp</p>';
            combined_list_html +=    
              '<p><span class="cart-item--price-title">\
                <a class="line-item__title link" style="cursor:pointer" href="'+product.ebook_1_filename+'" target="_blank">ebook 1 of ' +no_of_ebooks+ '</a>\
              </span></p>';
          }
          if (product.ebook_2_filename != null){
            
            //streams_list_html += '<p class="cart__remove">&nbsp</p>';
            //downloads_list_html += '<p class="cart__remove">&nbsp</p>';
            combined_list_html +=    
              '<p><span class="cart-item--price-title">\
                <a class="line-item__title link" style="cursor:pointer" href="'+product.ebook_2_filename+'" target="_blank">ebook 2 of ' +no_of_ebooks+ '</a>\
              </span></p>';
          }
          //End of Added because external links are being used instead of downloads from the server
      
        } else if (product.Type == "external_link"){
          console.log("external_link_product");
          if (product.ext_link_url_2 != null) {
            var no_of_external_links = 2;
          } else {
            if (product.ext_link_url_1 != null) {
              var no_of_external_links = 1;
            }  
          }
          if (product.ext_link_url_1 != null){
            product_title_action_html = '<a style="cursor:pointer" href="'+product.ext_link_url_1+'" target="_blank">'+product.Name+'</a><br>\
                                          <br><div display ="none" class="cart__remove" id="credentials_1_'+ product.ID +'" style="font-size:11px; display: none;"><div>';
            if (product.ext_link_url_2 != null){
              product_title_action_html += 'Link 1 ';
            }
            
            
              
            product_title_action_html += 'Password:<input class="form-field-input form-field-text" style="padding: .4rem .625rem .375rem !important;" readonly type="text" value="'+product.ext_link_pwd_1+'" size="40"></div>\
                                          <div>Website:<input class="form-field-input form-field-text" style="padding: .4rem .625rem .375rem !important;" readonly size="40" type="text" value="'+product.ext_link_url_1+'"></div></div>\
                                          <div id="extpwd_1_'+product.ID+'"  style="position:absolute; left:-9999px;">'+product.ext_link_pwd_1+'</div>';
            image_action_html = '<a style="cursor:pointer" href="'+product.ext_link_url_1+'" target="_blank"><img src="'+product.Image_url+'"'+hide_if_empty+'></a>';
            //streams_list_html += '<p class="cart__remove">&nbsp</p>';
            //downloads_list_html += '<p class="cart__remove">&nbsp</p>';
            combined_list_html +=    
              '<div><p>';
            if (product.ext_link_url_2 != null){
              combined_list_html +='<span class="cart-item--price-title line-item__title">Link 1: </span>';
            }
            if (product.ext_link_pwd_1 != null && product.ext_link_pwd_1 != 'none'){
              combined_list_html += '<a class="cart-item--price-title line-item__title link" style="cursor:pointer" onclick="CopyToClipboard(\'extpwd_1_'+product.ID+'\');return false;">Copy password to clipboard  <span style="position:relative; width:40px; height:30px; display:inline-block; vertical-align:middle;"><img id="extpwd_1_'+product.ID+'_cp_icon" position="relative" src="'+copyToClipboardIconSrc+'"></span></a></p></div>';
            }
            combined_list_html +=    
              '<p><a class="superf-item-button" href="'+product.ext_link_url_1+'" target="_blank" class="btn" style="float:none !important;">CLICK HERE</a></p>\
               <p><a class="cart__remove" style="cursor:pointer" onclick="toggle_visibility(\'credentials_1_'+ product.ID +'\');" id="vistoggle_credentials_1_'+ product.ID +'">Show URL/Password</a></p>';
          }
          if (product.ext_link_url_2 != null){
            product_title_action_html += '<br>\
                                         <br><div display ="none" class="cart__remove" id="credentials_2_'+ product.ID +'" style="font-size:11px; display: none;"><div>\
                                         Link 2: Password:<input class="form-field-input form-field-text" style="padding: .4rem .625rem .375rem !important;" readonly type="text" value="'+product.ext_link_pwd_2+'" size="40"></div>\
                                          <div>Website:<input class="form-field-input form-field-text" style="padding: .4rem .625rem .375rem !important;" readonly size="40" type="text" value="'+product.ext_link_url_2+'"></div></div>\
                                          <div id="extpwd_2_'+product.ID+'"  style="position:absolute; left:-9999px;">'+product.ext_link_pwd_2+'</div>';
            combined_list_html += '<div><p><span class="cart-item--price-title line-item__title">Link 2: </span>';
            if (product.ext_link_pwd_2 != null && product.ext_link_pwd_2 != 'none'){
              combined_list_html += '<a class="cart-item--price-title line-item__title link" style="cursor:pointer" onclick="CopyToClipboard(\'extpwd_2_'+product.ID+'\');return false;">Copy password to clipboard  <span style="position:relative; width:40px; height:30px; display:inline-block; vertical-align:middle;"><img id="extpwd_2_'+product.ID+'_cp_icon" position="relative" src="'+copyToClipboardIconSrc+'"></span></a></p></div>';
            } 
              combined_list_html += '<p><a class="superf-item-button" href="'+product.ext_link_url_2+'" target="_blank" class="btn" style="float:none !important;">CLICK HERE</a></p>\
               <p><a class="cart__remove" style="cursor:pointer" onclick="toggle_visibility(\'credentials_2_'+ product.ID +'\');" id="vistoggle_credentials_2_'+ product.ID +'">Show URL/Password</a></p>';
          }
        } else { // now we are dealing with only Murphys Magic download products.
          console.log("murphys product");
          // check if it is a video, if so, how many how parts are there, make html for parts links
          
          if (product.Type == 'Video'||product.Type == 'Mixed'||product.Type == 'Ebook'||product.Type == 'Event'){
            if (null != product.Files){
              // place different video parts into html to later insert into a cell
              var no_ofparts = product.Files.length;
              //console.log('Product name: '+product.Name);
              //console.log('Number of parts = '+no_ofparts);
              var video_num = 1;
              var pdf_num = 1;
              for (var i = 1; i <= no_ofparts; i++) {
                //console.log(i);
                var part_name = null;
                var video_link_name = null;
                var download_link_name = null;
                var part_id = null;
                var part_type = null;
  
                //console.log(product.Files[i-1]);
                if (product.Files[i-1].Type == '.mp4'){
                  video_link_name = 'Video '+video_num;
                  part_name = product.Files[i-1].Title.replace('\'','\\\'');
                  console.log(part_name);
                  if (part_name == ''){
                    part_name = 'Part ' + i;
                    console.log(part_name);
                  }
                  part_id = product.Files[i-1].ID;
                  part_type = product.Files[i-1].Type; 
  
                  //add product_title_action if not already set(we prefer to just use video)
                  if (product_title_action_html == ''){
                    product_title_action_html = '<a style="cursor:pointer" onclick="downloads_client.playVideo('+product.ID+','+i+',\''+product.Name.replace('\'','\\\'')+'\',\''+part_name+'\');">'+product.Name+'</a>';
                    image_action_html = '<a style="cursor:pointer" onclick="downloads_client.playVideo('+product.ID+','+i+',\''+product.Name.replace('\'','\\\'')+'\',\''+part_name+'\');"><img src="'+product.Image_url+'"'+hide_if_empty+'></a>';
                  }
  
                    //add new line to streams list
                  streams_list_html +=    
                    '<p id="'+part_id+'" class="cart__remove">\
                      <a class="line-item__title link" style="cursor:pointer" onclick="downloads_client.playVideo('+product.ID+','+i+',\''+product.Name.replace('\'','\\\'')+'\',\''+part_name+'\');">'+part_name+'</a>\
                    </p>';
                  //add new line to downloads list 
                  downloads_list_html += 
                    '<p id="'+part_id+'" class="cart__remove">\
                      <a class="line-item__title link" style="cursor:pointer" onclick="downloads_client.getDownloadLink('+product.ID+','+i+',\''+product.Name.replace('\'','\\\'')+'\','+part_id+').done(downloads_client.handleLink).fail(downloads_client.log_error2);">'+part_name+'</a>\
                    </p>';
                  combined_list_html +=    
                    '<p><span class="cart-item--price-title">\
                      <a class="line-item__title link" style="cursor:pointer" onclick="downloads_client.playVideo('+product.ID+','+i+',\''+product.Name.replace('\'','\\\'')+'\',\''+part_name+'\');">'+part_name+'</a>\
                    </span>\
                    <span class="money">\
                      <a class="line-item__title link" style="cursor:pointer" onclick="downloads_client.getDownloadLink('+product.ID+','+i+',\''+product.Name.replace('\'','\\\'')+'\','+part_id+').done(downloads_client.handleLink).fail(downloads_client.log_error2);">[download]</a>\
                    </span></p>';
                  video_num++;
                } else if (product.Files[i-1].Type == '.pdf' || product.Files[i-1].Type == '.mp3'){
                  console.log("B2");
                  download_link_name = 'pdf '+pdf_num;
                  part_name = product.Files[i-1].Title;
                  part_id = product.Files[i-1].ID;
                  part_type = product.Files[i-1].Type;
  
                  //add an empty line to streams list
                  streams_list_html += '<p class="cart__remove">&nbsp</p>';
                  //add a new line to downloads list
                  downloads_list_html +=    
                    '<p id="'+part_id+'" class="cart__remove">\
                      <a class="line-item__title link" style="cursor:pointer" onclick="downloads_client.getDownloadLink('+product.ID+','+i+',\''+product.Name.replace('\'','\\\'')+'\','+part_id+').done(downloads_client.handleLink).fail(downloads_client.log_error2);">'+part_name+' ('+part_type+')</a>\
                    </p>';
                  combined_list_html +=   
                    '<p><span class="cart-item--price-title">\
                      <a class="line-item__title link" style="cursor:pointer" onclick="downloads_client.getDownloadLink('+product.ID+','+i+',\''+product.Name.replace('\'','\\\'')+'\','+part_id+').done(downloads_client.handleLink).fail(downloads_client.log_error2);">'+part_name+' ('+part_type+')</a>\
                    </span></p>';
                  pdf_num++;
                } else { // for files of other types eg .zip files
                  console.log("B3");
                  download_link_name = 'other file type';
                  part_name = product.Files[i-1].Title;
                  part_id = product.Files[i-1].ID;
                  part_type = product.Files[i-1].Type;
  
                  //add an empty line to streams list
                  streams_list_html += '<p class="cart__remove">&nbsp</p>';
                  //add a new line to downloads list
                  downloads_list_html +=    
                    '<p id="'+part_id+'" class="cart__remove">\
                      <a class="line-item__title link" style="cursor:pointer" onclick="downloads_client.getDownloadLink('+product.ID+','+i+',\''+product.Name.replace('\'','\\\'')+'\','+part_id+').done(downloads_client.handleLink).fail(downloads_client.log_error2);">'+part_name+' ('+part_type+')</a>\
                    </p>';
                  combined_list_html += 
                    '<p><span class="cart-item--price-title">\
                      <a class="line-item__title link" style="cursor:pointer" onclick="downloads_client.getDownloadLink('+product.ID+','+i+',\''+product.Name.replace('\'','\\\'')+'\','+part_id+').done(downloads_client.handleLink).fail(downloads_client.log_error2);">'+part_name+' ('+part_type+')</a>\
                    </span></p>';
                }
  
              } // end for
            } // end if isset product.files

            if (null != product.LicenseCodes){
              if (null != product.LicenseCodes.LicenseCode){
                combined_list_html += '<div><p><span style="font-size: 13px;">License Code: '+product.LicenseCodes.LicenseCode+'</span></p></div>';
              }
              if (null != product.LicenseCodes.Url){
                combined_list_html += '<div><p><a href="'+product.LicenseCodes.Url+'">Register License</a></p></div>';
              }
            }

            if (null != product.Description){
              combined_list_html += '<p>'+product.Description+'</p>';
            }
      
          } /*else if (product.Type == 'Ebook'){ // Not needed.
            console.log("B1");
            download_link_name = 'eBook';
            part_name = product.Files[0].Title;
            part_id = product.Files[0].ID;
            part_type = product.Files[0].Type;

            //add an empty line to streams list
            streams_list_html += '<p class="cart__remove">&nbsp</p>';
            //add a new line to downloads list
            downloads_list_html +=    
              '<p id="'+part_id+'" class="cart__remove">\
                <a class="line-item__title link" style="cursor:pointer" onclick="downloads_client.getDownloadLink('+product.ID+','+1+',\''+callback_url+'\','+part_id+').done(downloads_client.handleLink).fail(downloads_client.log_error2);">'+download_link_name+' ('+part_type+')</a>\
              </p>'; 
          } */

          //console.log('product: ');
          //console.log(product.Name);

          
        } // end else
  
        if (product_title_action_html != ''){
          var product_title_display_html = product_title_action_html;
          var image_display_html = image_action_html;
        } else {
          var product_title_display_html = product.Name;
          var image_display_html = '<img src="'+product.Image_url+'"'+hide_if_empty+'>';
        }      
  
        document.getElementById("downloaditems").innerHTML +=
        // PRODUCT LINE HTML GOES HERE        
          '<li class="cart-item">\
            <figure class="cart-item--image-wrapper">\
              '+image_display_html+'\
            </figure>\
\
            <div class="cart-item--inner">\
              <div class="cart-item--content">\
                <h3 class="cart-item--content-title">\
                  '+product_title_display_html+'\
                </h3>\
                <div class="video_position" id="video_goes_here'+product.ID+'"></div>\
              </div>\
              <div class="cart-item--info">\
                <div class="cart-item--content-price">\
                  '+combined_list_html+'\
                </div>\
              </div>\
            </div>\
          </li>';      
        
      }
     
    }


    else {
      var response = obj.error;
      if (response == "No downloads available for this account." || response == "Customer not found")
      {
        response = "No downloads available for this account.";
        //console.log("testing");  
        document.getElementById("downloaditems").innerHTML +=    
            '<tr class="line-item">\
			  <div>\
                <td class="line-item__product-info">\
                  <div class="line-item__product-info-wrapper">\
                    <div class="line-item__meta">\
                      <p>'+response+'</p>\
                    </div>\
                  </div>\
                </td>\
			  </div>\
            </tr>';
      }
          
      console.log(response);
    }
  }

  function log_error(obj, textstatus) {
    console.log("ERROR in json response: ");
    console.log(obj);
    //console.log(textstatus);
    if( !('error' in obj) ) {
      var response = obj.result;
    }
    else {
      var response = obj.error;
    }
  }

  //call ajax immediately on page load but first check if the element sfd-mmlink-data exists. This indicates that we have already sourced the thumbnails from liquid.
  const sfdDataElement = document.getElementById("sfd-mmlink-data");
  if (sfdDataElement){
    // if the element already exists, parse the JSON from the attribute
    murphysDownloadsShopifyResources = JSON.parse(sfdDataElement.getAttribute("murphys_downloads_shopify_resources_json"));
    nonMurphysDownloadsShopifyResources = JSON.parse(sfdDataElement.getAttribute("non_murphys_downloads_json"));
    externalLinksResources = JSON.parse(sfdDataElement.getAttribute("external_links_json"));
    copyToClipboardIconSrc = sfdDataElement.getAttribute("copy_to_clipboard_icon_src");
  }
  console.log("================================================================");
  console.log("murphysDownloadsShopifyResources from Liquid:", murphysDownloadsShopifyResources);
  console.log("nonMurphysDownloadsShopifyResources from Liquid:", nonMurphysDownloadsShopifyResources);
  console.log("externalLinksResources from Liquid:", externalLinksResources);
  console.log("copyToClipboardIconSrc from Liquid:", copyToClipboardIconSrc);
  console.log("================================================================");
  
  // Wrapper function to pass 'thumbnailsAndTitlesAlreadySourced' flag to handleData
  function handleDataWrapper(data, textstatus) {
    handleData(data, textstatus, murphysDownloadsShopifyResources, nonMurphysDownloadsShopifyResources, externalLinksResources, copyToClipboardIconSrc); // Call handleData with the flag
  }

  getData().done(handleDataWrapper).fail(log_error);

  return {
    playVimeoVideo: function(product_id, product_name, part_name, video_url) {
      //document.getElementById("video_goes_here"+product_id).innerHTML = '<div width=100% autoplay controls style="padding: 30px;"><p style="text-align: center;"><img src="https://cdn.shopify.com/s/images/spinner_big.gif"/></p></div>';
      var all_video_elements = document.getElementsByClassName("video_position");
      var no_of_video_elements = all_video_elements.length;                                            
      for (var numb = 0;  numb < no_of_video_elements; numb++) {
        all_video_elements[numb].innerHTML = '';                                              
      }
      document.getElementById("video_goes_here"+product_id).innerHTML = '<div width=100% style="padding:56.25% 0 0 0;position:relative;"><iframe src="'+video_url.replace("vimeo.com", "player.vimeo.com/video")+'?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Portable - Trailer"></iframe></div>';
      
    },
                                                      
    playVideo: function(product_id, part, product_name, part_name) {
      document.getElementById("video_goes_here"+product_id).innerHTML = '<div width=100% autoplay controls style="padding: 30px;"><p style="text-align: center;"><img src="https://cdn.shopify.com/s/images/spinner_big.gif"/></p></div>';
      downloads_client.streamVideo(product_id, part, product_name, part_name).done(downloads_client.handleStream).fail(downloads_client.log_error2);      
    },
    
  	streamVideo: function(product_id, part, product_name, part_name) {
      return $.ajax({
      type: "GET",
      url: shopify_frontend_endpoint_url,
      dataType: 'json',
        indexValue: {param1:product_name,param2:part_name,param3:product_id},
      data: {functionname: 'streamVideo', arguments: [customer_email, product_id, part], hmacdigest: hmac_digest, nonce: nonce},
      });
    },
    
    handleStream: function(obj, textstatus) {
      //console.log("handling stream now");
      //console.log(obj);
      //console.log(textstatus);
      var product_name = this.indexValue.param1;
      var part_name = this.indexValue.param2;
      var product_id = this.indexValue.param3;                                                
      if( !('error' in obj) ) {
        video_url = decodeURIComponent(obj.result);
        //console.log("video_url in handleStream function: ");
        //console.log(video_url);
                                                      
        var all_video_elements = document.getElementsByClassName("video_position");
        var no_of_video_elements = all_video_elements.length;                                            
        for (var numb = 0;  numb < no_of_video_elements; numb++) {
          all_video_elements[numb].innerHTML = '';                                              
        }
                                                      
        document.getElementById("video_goes_here"+product_id).innerHTML =
          //VIDEO PLAYER HTML GOES HERE
          //'\
		  //<div class="text--strong">'+product_name+'</div>\
          //<div class="text">'+part_name+'</div>\

          '<div>\
            <video class="mobile-friendly-video" width=100% autoplay controls>\
              <source src="'+video_url+'" type="video/mp4">\
               Your browser does not support the video tag.\
            </video>\
          </div>';
      }
      else {
        var response = obj.error;
		//console.log(response);
      }   
    },
    
    getDownloadLink: function(product_id, part=null, callback_url=null, part_id) {
      //part id is used to identify the html insertion point in the ajax callback function
      /*if (part = null){
      	part = part_id; // part_id uses file_id which can also be used to identify the files.
        				// part numbers start from 1, 2, 3, etc, while file ids are five digits.
      }*/
      return $.ajax({
      type: "GET",
      url: shopify_frontend_endpoint_url,
      indexValue: {param1:part_id,param2:product_id,param3:customer_email,param4:part,param5:callback_url},
      dataType: 'json',
      /*data: {functionname: 'add', arguments: [1, 2]},*/
      data: {functionname: 'getDownloadLink', arguments: [customer_email, product_id, part, callback_url], hmacdigest: hmac_digest, nonce: nonce},
      });
    },
    
    handleLink: function(obj, textstatus) {
      //console.log("handling link now");
      //console.log(obj);
      //console.log(textstatus);
      //console.log("----------");
     
      var html_insertion_point_id = this.indexValue.param1;
      var product_id = this.indexValue.param2;
      var email = this.indexValue.param3;
      var part = this.indexValue.param4;
      var callback_url = this.indexValue.param5;
      
      //console.log('here is the part_id: '+ html_insertion_point_id);
    
      if( !('error' in obj) ) {
        //console.log("no error: ");
        //console.log(obj);
        
        if (obj.result == null){
          //console.log("Invalid response: ");
          //console.log(obj);
        
        } else if (obj.result.Status == 'ready'){
          var download_url = obj.result.DownloadLink;
          var status = 'ready';
          //console.log("download_url in handlelink function: ");
          //console.log(download_url);
          
          //redirect to download url
          window.location = download_url;
        
        } else if (obj.result.Status == 'queued'){
          var status = 'queued' ;
          document.getElementById(html_insertion_point_id).innerHTML =
            '<a class="line-item__title link" style="cursor:pointer" onclick="downloads_client.getDownloadLink('+product_id+','+part+',\''+callback_url+'\','+html_insertion_point_id+').done(downloads_client.handleLink).fail(downloads_client.log_error2);">"'+Status+'"</a>';
          	    
        } else if (obj.result.Status == 'watermarking'){
          var percent_complete = obj.result.PercentComplete;
          var status = 'watermarking... '+percent_complete+'% complete';
          document.getElementById(html_insertion_point_id).innerHTML =
          	'<a class="line-item__title link">'+status+'</a>';
        } 
        
      }
      else {
        var response = obj.error;
		//console.log(response);
      }   
    },
      
    getEbook2: function(product_id, product_name, part_name, ebook_file_name, filename_hmac_digest) { 
      //part id is used to identify the html insertion point in the ajax callback function
      /*if (part = null){
      	part = part_id; // part_id uses file_id which can also be used to identify the files.
        				// part numbers start from 1, 2, 3, etc, while file ids are five digits.
      }*/
      
      return $.ajax({
      type: "GET",
      url: shopify_frontend_endpoint_url,
      indexValue: {param1:ebook_file_name,param2:product_id,param3:customer_email,param4:part_name},
      dataType: 'json',
      data: {functionname: 'getEbook', arguments: [customer_email, ebook_file_name, filename_hmac_digest], hmacdigest: hmac_digest, nonce: nonce},
      });
    },
    
    getEbook: function(product_id, product_name, part_name, ebook_file_name, filename_hmac_digest) { 
        ebook_download_url = shopify_frontend_endpoint_url + '?functionname=getEbook&arguments[]=' + customer_email + '&arguments[]=' + ebook_file_name + '&arguments[]=' + filename_hmac_digest + '&hmacdigest=' + hmac_digest + '&nonce=' + nonce;
        window.location = ebook_download_url;   
    },
    
    handleEbookLink: function(obj, textstatus) {
      //console.log("handling link now");
      //console.log(obj);
      //console.log(textstatus);
      //console.log("----------");
     
      var html_insertion_point_id = this.indexValue.param1;
      var product_id = this.indexValue.param2;
      var email = this.indexValue.param3;
      var part = this.indexValue.param4;
      var callback_url = this.indexValue.param5;
      
      //console.log('here is the part_id: '+ html_insertion_point_id);
    
      if( !('error' in obj) ) {
        //console.log("no error: ");
        //console.log(obj);
        
        if (obj.result == null){
          //console.log("Invalid response: ");
          //console.log(obj);
        
        } else if (obj.result.Status == 'ready'){
          var download_url = obj.result.DownloadLink;
          var status = 'ready';
          //console.log("download_url in handlelink function: ");
          //console.log(download_url);
          
          //redirect to download url
          window.location = download_url;
        
        } else if (obj.result.Status == 'queued'){
          var status = 'queued' ;
          document.getElementById(html_insertion_point_id).innerHTML =
            '<a class="line-item__title link" style="cursor:pointer" onclick="downloads_client.getDownloadLink('+product_id+','+part+',\''+callback_url+'\','+html_insertion_point_id+').done(downloads_client.handleLink).fail(downloads_client.log_error2);">"'+Status+'"</a>';
          	    
        } else if (obj.result.Status == 'watermarking'){
          var percent_complete = obj.result.PercentComplete;
          var status = 'watermarking... '+percent_complete+'% complete';
          document.getElementById(html_insertion_point_id).innerHTML =
          	'<a class="line-item__title link">'+status+'</a>';
        } 
        
      }
      else {
        var response = obj.error;
		//console.log(response);
      }   
    },
    
    log_error2: function(obj, textstatus) {
      console.log("ERROR (2) in json response: ");
      console.log(obj);
      //console.log(textstatus);
      if( !('error' in obj) ) {
        var response = obj.result;
      }
      else {
        var response = obj.error;
      }
  	}
  } 
}

function toggle_visibility(id) {
       console.log("toggling visibility for"+id);
       var e = document.getElementById(id);
       var f = document.getElementById("vistoggle_"+id);
       console.log("e" + e);
       console.log("f" + f);
       if(e.style.display == 'block'){
          e.style.display = 'none';
          f.innerHTML ='Show URL/Password';
       } else {
          e.style.display = 'block';
          f.innerHTML ='Hide URL/Password';
       }
} 

function CopyToClipboard(id)
{
console.log("Text copied");
console.log(id);
var r = document.createRange();
r.selectNode(document.getElementById(id));
window.getSelection().removeAllRanges();
window.getSelection().addRange(r);
var copied = document.execCommand('copy');
window.getSelection().removeAllRanges();
console.log("copied? : " + copied);
if (copied){
  jump_animation(id+"_cp_icon");
}

}  
  
$().ready(function(){
    //icon_jump_animation
    jqueryFunctionJumpAnimation = function( element_id ) {
        console.log("#" + element_id);
        //alert( "Password copied to clipboard" );
    $("#" + element_id).animate({
    //left: '250px',
    height: '-=4px',
    //width: '+=150px'
    },100).animate({
    //left: '250px',
    height: '+=4px',
    //width: '+=150px'
    },100);
    }
})

//javascript function
function jump_animation(element_id)
{
    //Invoke jQuery Function
    jqueryFunctionJumpAnimation(element_id);
}
